export class AbstractBlockchainService {
    constructor() {
        this.parseError = async (error) => {
            if (typeof error === 'object' && error !== null && 'data' in error && typeof error.data === 'string') {
                for (const contractInstance of await this.getContractInstances()) {
                    const parsedError = contractInstance.interface.parseError(error.data);
                    if (parsedError != null) {
                        return parsedError;
                    }
                }
            }
            return error;
        };
    }
    async callContract(contract, callback) {
        try {
            const result = await callback(contract);
            return result;
        }
        catch (error) {
            const parsedError = await this.parseError(error);
            throw parsedError;
        }
    }
    async waitForTransactionConfirmation(contract, callback) {
        const transaction = await this.callContract(contract, async (contract) => {
            const tx = await callback(contract);
            return tx;
        });
        await transaction.wait();
    }
}
//# sourceMappingURL=abstract-blockchain-service.js.map